import React from "react"
import ContentTransformer from "../../../src/components/Transformers/content-transformer"
import {
  newsletterContainer,
  newsletterContent,
  newsletterTitle,
  newsletterDate,
  actualiteInfos,
  actualiteCategorie,
  actualiteTitle,
  actualiteResume,
  actualiteContainerFirst,
  listActualitesContainer,
  actualiteContainer,
  eventsContainer,
  eventsItem,
  eventsItemImg,
  eventsItemDate,
  eventsItemDateFrom,
  eventsItemDateTo,
  eventsItemTaxo,
  eventsItemTitle,
} from "./newsletter.module.scss"
import PropTypes from "prop-types"
import TransitionFade from "../transition-fade"
import NonStretchedImage from "../Image/non-stretched-image"
import {
  NewsletterIntro,
  ArticleHeader,
  EventsItemImg,
  Taxo,
  EventsItem,
  Container,
} from "../../templates/details/styled-components/newsletter-styled"
import SummaryTransformer from "../Transformers/summary-transformer"
import { summaryLength } from "../../constants"
import "moment/locale/fr"

//-----------------------Parent component---------------------------//

const Newsletter = ({ newsletter }) => {
  return (
    <Container className={newsletterContainer}>
      <NewsletterHeader newsletter={newsletter} />
      {newsletter.body && (
        <ContentTransformer content={newsletter.body.processed} />
      )}
      {newsletter.relationships.field_actualite?.length > 0 && (
        <>
          <NewsletterIntro>Nos actualités</NewsletterIntro>
          <NewsletterActualite
            actualite={newsletter.relationships.field_actualite}
          />
        </>
      )}
      {newsletter.relationships.field_evenements?.length > 0 && (
        <>
          <NewsletterIntro>Les événements :</NewsletterIntro>
          <NewsletterEvenement
            evenement={newsletter.relationships.field_evenements}
          />
        </>
      )}
    </Container>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component/Header---------------------------//

const NewsletterHeader = ({ newsletter }) => (
  <ArticleHeader className={newsletterContent}>
    <h1 className={newsletterTitle}>{newsletter.title}</h1>
    <p className={newsletterDate}>{newsletter.field_date_issue}</p>
  </ArticleHeader>
)

//-----------------------Child component/Header---------------------------//

//-----------------------Child component/Actualite---------------------------//

const NewsletterActualite = ({ actualite }) => {
  const actus = actualite
  const firstActu = actus[0]
  return (
    <>
      <ul className={listActualitesContainer}>
        <li>
          <TransitionFade link={firstActu.path.alias}>
            <ActuItem myClassName={actualiteContainerFirst} actu={firstActu} />
          </TransitionFade>
        </li>
        {actus.slice(1).map((element) => {
          return (
            <li key={element.drupal_id}>
              <ActuItem myClassName={actualiteContainer} actu={element} />
            </li>
          )
        })}
      </ul>
    </>
  )
}

const ActuItem = ({ actu, myClassName }) => {
  let image = ""
  let title = ""
  if (myClassName === actualiteContainerFirst) {
    image = (
      <NonStretchedImage
        {...actu.relationships.field_image_actus?.localFile}
        ariaHidden={true}
      />
    )
    title = <div>{actu.title}</div>
  } else {
    image = (
      <TransitionFade arialabel={actu.title} link={actu.path.alias}>
        <NonStretchedImage
          {...actu.relationships.field_image_actus?.localFile}
          ariaHidden={true}
        />
      </TransitionFade>
    )
    title = <TransitionFade link={actu.path.alias}>{actu.title}</TransitionFade>
  }
  return (
    <div className={myClassName}>
      {actu.relationships.field_image_actus?.localFile && <>{image}</>}
      <div className={actualiteInfos}>
        {actu.relationships.field_taxonomie_thematique?.length > 0 && (
          <div className={actualiteCategorie}>
            <Taxo>{actu.relationships.field_taxonomie_thematique[0].name}</Taxo>
          </div>
        )}
        <h3 className={actualiteTitle}>{title}</h3>
        {actu.body && (
          <p
            className={actualiteResume}
            dangerouslySetInnerHTML={{
              __html: SummaryTransformer(actu.body, summaryLength),
            }}
          />
        )}
      </div>
    </div>
  )
}

//-----------------------Child component/Actualite---------------------------//

//-----------------------Child component/Evenement---------------------------//

const NewsletterEvenement = ({ evenement }) => {
  return (
    <ul className={eventsContainer}>
      {evenement.map((element, index) => (
        <EventsItem key={index} className={eventsItem}>
          <EvenementContent evenement={element} />
        </EventsItem>
      ))}
    </ul>
  )
}

const EvenementContent = ({ evenement }) => (
  <>
    <EventsItemImg className={eventsItemImg}>
      {evenement.relationships.field_image_event?.localFile && (
        <TransitionFade arialabel={evenement.title} link={evenement.path.alias}>
          <NonStretchedImage
            {...evenement.relationships.field_image_event.localFile}
            ariaHidden={true}
          />
        </TransitionFade>
      )}
    </EventsItemImg>
    <div className={eventsItemDate}>
      <p>
        {!evenement.fields.formatted_field_date_de_fin ? (
          <span className={eventsItemDateFrom}>
            {evenement.fields.formatted_field_date_de_debut}
          </span>
        ) : (
          <>
            <span className={eventsItemDateFrom}>
              Du {evenement.fields.formatted_field_date_de_debut}
            </span>
            <span className={eventsItemDateTo}>
              {" "}
              au {evenement.fields.formatted_field_date_de_fin}
            </span>
          </>
        )}
      </p>
    </div>
    {evenement.relationships.field_taxonomie_thematique?.length > 0 && (
      <Taxo className={eventsItemTaxo}>
        {evenement.relationships.field_taxonomie_thematique[0].name}
      </Taxo>
    )}
    <div className={eventsItemTitle}>
      <TransitionFade link={evenement.path.alias}>
        {evenement.title}
      </TransitionFade>
    </div>
  </>
)

//-----------------------Child component/Evenement---------------------------//

//-----------------------Prop-Types---------------------------//

Newsletter.propTypes = {
  newsletter: PropTypes.object.isRequired,
  isIndex: PropTypes.bool,
}
NewsletterHeader.propTypes = {
  newsletter: PropTypes.object.isRequired,
}
NewsletterActualite.propTypes = {
  actualite: PropTypes.array.isRequired,
}
ActuItem.propTypes = {
  actu: PropTypes.object.isRequired,
  myClassName: PropTypes.string.isRequired,
}
NewsletterEvenement.propTypes = {
  evenement: PropTypes.array.isRequired,
}
EvenementContent.propTypes = {
  evenement: PropTypes.object.isRequired,
}
//-----------------------Prop-Types---------------------------//

export default Newsletter
